import { createApp } from 'vue'
import App from './App.vue'
import './styles.scss'

createApp(App).mount('#app')
